/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const EditIcon = /*#__PURE__*/ createSvgIcon(
  'EditIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M4.5 15.5h1.063l7.812-7.813-1.063-1.062L4.5 14.438V15.5zM3.754 17a.735.735 0 01-.535-.215.714.714 0 01-.219-.531v-1.81c0-.199.035-.388.104-.569.07-.18.18-.347.333-.5l9.938-9.938A1.443 1.443 0 0114.435 3c.196 0 .384.035.565.104.18.07.347.18.5.333L16.563 4.5c.152.153.263.32.333.5s.104.365.104.553c0 .2-.035.392-.105.574-.07.181-.18.348-.332.498l-9.938 9.938c-.153.152-.32.263-.499.333a1.56 1.56 0 01-.567.104H3.754zm9.08-9.834l-.521-.541 1.062 1.063-.54-.522z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default EditIcon;
